import { graphql } from "react-relay";

export const update_scheduled_lesson_block_time = graphql`
  mutation UpdateScheduledLessonBlockTimeMutation(
    $input: UpdateScheduledLessonBlockTimeInput!
    $startingYear: Int
    $block: Int
  ) {
    updateScheduledLessonBlockTime(input: $input) {
      success
      errors
      lessonBlocks {
        id
        lessonDay
        lessonTime
        teacher {
          id
          teachingDays(startingYear: $startingYear, block: $block)
        }
        lessons {
          edges {
            node {
              scheduledTimestamp
            }
          }
        }
      }
    }
  }
`;
